export interface BlogCategory {
  slug: string;
  name: string;
  description: string;
  gradient: string;
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  {
    slug: "fetiches-e-fantasias",
    name: "Fetiches e Fantasias",
    description:
      "Fetiches, fantasias e desejos explicados sem tabu, sem julgamento e sem caricatura. Conteúdo para quem quer explorar com segurança, conversar melhor com o parceiro e entender o que realmente faz sentido para si.",
    gradient: "from-orange-500 to-rose-600",
  },
  {
    slug: "praticas-sexuais",
    name: "Práticas sexuais",
    description:
      "Tudo sobre práticas sexuais — posições, técnicas, sexo oral, anal e muito mais. Conteúdo direto, sem rodeios, para quem quer aprender de verdade o que funciona na cama. Sem eufemismos, sem julgamento.",
    gradient: "from-pink-500 to-rose-500",
  },
  {
    slug: "prazer-e-orgasmo",
    name: "Prazer e Orgasmo",
    description:
      "Guias práticos sobre orgasmo feminino, masturbação e autoconhecimento. Porque entender o próprio corpo é o primeiro passo para uma vida sexual de verdade satisfatória — e isso se aprende.",
    gradient: "from-fuchsia-600 to-pink-600",
  },
  {
    slug: "relacionamento-e-comunicacao",
    name: "Relacionamento & comunicação",
    description:
      "Sexo começa muito antes da cama. Aqui você encontra conteúdo sobre comunicação íntima, desejo, rotina sexual e tudo que envolve a vida a dois — sem moralismo e sem receita de bolo.",
    gradient: "from-pink-600 to-rose-600",
  },
  {
    slug: "saude-sexual",
    name: "Saúde Sexual",
    description:
      "Ejaculação precoce, ereção, sexo na gravidez e outros temas de saúde sexual explicados com clareza. Informação baseada em evidências, linguagem acessível e sem o tom de consultório que faz todo mundo querer fugir.",
    gradient: "from-indigo-700 to-purple-600",
  },
  {
    slug: "sexualidade-e-identidade",
    name: "Sexualidade e Identidade",
    description:
      "Orientação sexual, identidade de gênero e diversidade explicadas sem rodeios. Conteúdo para quem quer entender melhor a si mesmo, o parceiro ou simplesmente o mundo — sem julgamento, sem simplificação.",
    gradient: "from-violet-600 to-purple-600",
  },
];

export const BLOG_CATEGORY_NAMES = BLOG_CATEGORIES.map((category) => category.name);

export function getBlogCategoryBySlug(slug: string) {
  return BLOG_CATEGORIES.find((category) => category.slug === slug) ?? null;
}

export function getBlogCategoryByName(name: string) {
  return BLOG_CATEGORIES.find((category) => category.name === name) ?? null;
}

export function getBlogCategoryGradient(name: string) {
  return getBlogCategoryByName(name)?.gradient ?? "from-pink-600 to-fuchsia-600";
}
